
// *** Initialize ranking page condition display ***
export function initFundListCondition() {
    let fundListObj = getFundListObj();
    if (fundListObj) {
        // console.log('select count', fundListObj.find('select').length);
        if ($('#rankingList').length > 0 ) {
            return;
        }
        let select_list = fundListObj.find('select');
        // search result skip
        if(select_list.attr("id") != "search_result_sort"){
            for( let i = 0; i < select_list.length; i++) {
                select_list[i].selectedIndex = 0;
                if ($(select_list[i]).attr('id') == 'rankingTermList') {
                    select_list[i].selectedIndex = $(select_list[i]).find('option[value=12]').index();
                }
            }
        }

    }
    // init mobile condition
    // category
    let value1 = $.url.attr("path") || '0';
    let select1 = $('.sp_ranking_box select.ranking_page_list');
    if (select1.find("option[value='"+ value1 +"']").length > 0) {
        select1[0].selectedIndex = select1.find("option[value='"+ value1 +"']").index();
    }
    // term
    let value2 = $.url.param("term") || 12;
    let select2 = $('.sp_ranking_box select#rankingTermList');
    if (select2.find("option[value='"+ value2 +"']").length > 0) {
        select2[0].selectedIndex = select2.find("option[value='"+ value2 +"']").index();
    }
    // large
    let value3 = $.url.param("large_class") || 0;
    let select3 = $('.sp_ranking_box select#rankingLargeClassList');
    if (select3.find("option[value='"+ value3 +"']").length > 0) {
        select3[0].selectedIndex = select3.find("option[value='"+ value3 +"']").index();
    }
    // middle
    let value4 = $.url.param("middle_class") || 0;
    let select4 = $('.sp_ranking_box select#rankingMiddleClassList');
    if (select4.find("option[value='"+ value4 +"']").length > 0) {
        select4[0].selectedIndex = select4.find("option[value='"+ value4 +"']").index();
    }
    // small
    let value5 = $.url.param("small_class") || 0;
    let select5 = $('.sp_ranking_box select#rankingSmallClassList');
    if (select5.find("option[value='"+ value5 +"']").length > 0) {
        select5[0].selectedIndex = select5.find("option[value='"+ value5 +"']").index();
    }
    // index_id
    let value6 = $.url.param("index_id") || 0;
    let select6 = $('.sp_ranking_box select#rankingIndexId');
    if (select6.find("option[value='"+ value6 +"']").length > 0) {
        select6[0].selectedIndex = select6.find("option[value='"+ value6 +"']").index();
    }
    // sort
    let value7 = $.url.param("sort") || 'asc';
    let select7 = $('.sp_ranking_box select#rankingSort');
    if (select7.find("option[value='"+ value7 +"']").length > 0) {
        select7[0].selectedIndex = select7.find("option[value='"+ value7 +"']").index();
    }
}

// sp page[ranking/search_result] init header copy for scroll fixed
export function initSpRankingHeader() {
    let ranking = $("body.sp_body .sp_compare_table");
    if(ranking.length > 0 && $("body.sp_body .sp_table_layer").length == 0){
        ranking.find('th').each(function(){
            $(this).css('width', $(this).width() + 'px');
        });

        let fix_header_box = $('<div></div>');
        fix_header_box.addClass('sp_table_layer');
        ranking.before(fix_header_box);

        let fix_header = $("body.sp_body .sp_compare_table").clone();
        fix_header.find('tbody').remove();
        fix_header.find('tfoot').remove();
        fix_header_box.append(fix_header);
    }
}

// sp page[ranking/search_result] header fixed
export function fixedSpRankingHeader() {
    //sp_compare_table fixed
    if($("body").hasClass("sp_body")){
        if($(".pageCon_left").hasClass("pageCon_rankings")||$(".pageCon_left").hasClass("pageCon_collect")||$(".pageCon_left").hasClass("pageCon_screenings")){
            if($(".sp_compare_table_box").length>0){
                $(".sp_body .sp_table_layer").height($(".sp_compare_table_box>.sp_compare_table thead").height());
                $("#newFooter").removeClass("no_result");
                let boxTop=$(".sp_compare_table_box").offset().top;
                if($(".sp_body .sp_compare_table ").eq(1).find("tr").size()>=5){
                    if($(window).scrollTop()>=boxTop-40){
                        $(".sp_body .sp_table_layer").show();
                    }else{
                        $(".sp_body .sp_table_layer ").hide();
                    }
                }
            }else{
                $("#newFooter").addClass("no_result");
            }
        }
    }
}

export default { initFundListCondition, initSpRankingHeader, fixedSpRankingHeader };